class TextBlock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.dataset.layout !== 'carousel') return

    const track = this.els.track?.element

    if (!track) return

    this.resizeObserver = new ResizeObserver(() => {
      this.updateOverflow()
    })

    this.resizeObserver.observe(track)

    this.updateOverflow()
  }

  updateOverflow () {
    const track = this.els.track?.element

    if (!track) return

    track.dataset.overflowing =
      track.scrollWidth > track.clientWidth
        ? 'true'
        : 'false'
  }

  disconnectedCallback () {
    this.resizeObserver?.disconnect()

    super.disconnectedCallback()
  }
}

if (!customElements.get('text-block')) {
  customElements.define('text-block', TextBlock)
}